/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EmploymentAndTaxDetailsViewModel } from './EmploymentAndTaxDetailsViewModel';
import {
    EmploymentAndTaxDetailsViewModelFromJSON,
    EmploymentAndTaxDetailsViewModelFromJSONTyped,
    EmploymentAndTaxDetailsViewModelToJSON,
} from './EmploymentAndTaxDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfEmploymentAndTaxDetailsViewModel
 */
export interface ResultOfEmploymentAndTaxDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfEmploymentAndTaxDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfEmploymentAndTaxDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfEmploymentAndTaxDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfEmploymentAndTaxDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfEmploymentAndTaxDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfEmploymentAndTaxDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfEmploymentAndTaxDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {EmploymentAndTaxDetailsViewModel}
     * @memberof ResultOfEmploymentAndTaxDetailsViewModel
     */
    data?: EmploymentAndTaxDetailsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfEmploymentAndTaxDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfEmploymentAndTaxDetailsViewModel interface.
 */
export function instanceOfResultOfEmploymentAndTaxDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfEmploymentAndTaxDetailsViewModelFromJSON(json: any): ResultOfEmploymentAndTaxDetailsViewModel {
    return ResultOfEmploymentAndTaxDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfEmploymentAndTaxDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfEmploymentAndTaxDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : EmploymentAndTaxDetailsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfEmploymentAndTaxDetailsViewModelToJSON(value?: ResultOfEmploymentAndTaxDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': EmploymentAndTaxDetailsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

